<template>
  <div v-if="this.isLoggedIn" class="body-index1">
    <!-- <Tab
      v-if="!isMobileFlag"
      :tablist="list"
      @change="changeTab"
      :tabCurrent="current"
    />
    <mTab
      v-else
      :tablist="list"
      @change="changeTab"
      :tabCurrent="current"
    /> -->
    <Content
      v-for="(item, index) in list"
      v-if="index == current"
      :key="index"
      :tabContent="item"
      :isSearching="isSearching"
      @search="searchPreview"
    />

    <PreviewTable
      :data="previewData"
      :loading="previewLoading"
      :submitting="isSubmitting"
      v-if="showPreviewTable"
      @delete="deletePreviewItem"
      @clear="clearPreview"
      @submit="submitWorkOrder"
    />

    <Table
      :data="tableDatas"
      v-if="showTable"
      v-loading="tableLoading"
      @refreshStatus="refreshOrderStatus"
    />


  </div>
  <div v-else class="page">
    <div class="main">
      <el-button type="primary" @click="backToHome">去登录</el-button>
    </div>
  </div>
</template>

<script>
import Tab from "./module/tab.vue";
import mTab from "./module/mtab.vue";
import Table from "./module/table.vue";
import Content from "./module/content.vue";
import PreviewTable from "./module/previewTable.vue";
import TabTitle from "@/components/TabTitle.vue";
import { message } from "@/utils/resetMessage";
import {
  getTempUser,
  getToken,
} from "../../utils/storage";
import { submitWorkOrder, queryWorkOrderStatus } from "../../api/workOrder";
import { searchImage, reDownload } from "../../api/downLoad";

export default {
  components: {
    Tab,
    Table,
    Content,
    PreviewTable,
    mTab,
    TabTitle,
  },
  data() {
    return {
      isLoggedIn: false,
      current: 0,
      list: [
        {
          title: "SS/战库人工下载",
          subTitle: "仅支持SS/战库",
          titleState: "success",
          tip: '<ul><li>提交SS/战库素材ID，客服人员会在30分钟内完成下载并返回下载链接</li><li>仅支持战库/SS素材网站的图片下载，如提交其他素材网ID导致扣费，无法退费！</li><li>提交后会立刻扣费，并进入等待模式（通常需要10-30分钟），等待过程中无法取消订单，如无法下载或30分钟超时失败，费用会自动退回</li><li>30分钟超时失败会自动退款，如您还需要这个ID，可以重新再次提交，重新等待</li></ul>',
          label: null,
          isPop: false,
          webType: "shutterstock",
          icon: "",
          status: true,
        },
      ],
      tableDatas: [],
      isMobileFlag: false,
      showTable: false,
      tableLoading: false,
      isSearching: false,
      // 预览相关
      previewData: [],
      showPreviewTable: false,
      previewLoading: false,
      isSubmitting: false,
      timer: null,
      // 已弹过“下载完成”提示的工单ID，避免同一工单重复提示
      notifiedOrderIds: [],
      // 历史记录相关
      historyList: [],
      historyLoading: false,
      historyPageNo: 1,
      historyPageSize: 10,
      historyTotal: 0,
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.isMobileFlag = true;
    } else {
      this.isMobileFlag = false;
    }
    this.isLoggedIn = getToken() !== null && getToken() != "" && getTempUser() != "temp" ? true : false;

    if (this.isLoggedIn) {
      this.changeTab(0);
      this.$store.commit("headerMenuId", 0);
      this.$store.commit("asideMenuId", "workOrderDown");
      // 加载历史工单列表（顶部表格）
      this.loadWorkOrders();
      // 加载工单历史记录（底部表格）
      this.loadWorkOrderHistory();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    changeTab(index) {
      this.current = index;
      this.tableDatas = [];
      this.isSearching = false;
      this.showTable = false;
      this.tableLoading = false;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    backToHome() {
      this.$router.push("/login");
    },
    // 搜索预览素材
    async searchPreview(params) {
      if (!this.isLoggedIn) {
        message.error({
          message: "您还没登录用户，请登录",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }

      if (params.length > 50) {
        message.error({
          message: "每个工单最多提交50个素材ID",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }

      this.isSearching = true;
      this.previewLoading = true;
      this.showPreviewTable = true;
      this.previewData = [];

      // 逐个搜索素材ID
      for (let i = 0; i < params.length; i++) {
        const imageID = params[i];
        const dataform = {
          webType: this.list[this.current].webType,
          imageID: imageID,
          searchType: "workOrder",
        };

        try {
          const res = await searchImage(dataform);
          if (res && res.status === 0) {
            // 搜索成功，构建预览数据
            // 优先使用 workOrderPrice（工单价格），否则使用普通 price
            const displayPrice = res.workOrderPrice !== undefined && res.workOrderPrice !== null
              ? res.workOrderPrice
              : (res.price || 0);
            // 判断是否免费（已购买过）
            const isFree = res.detailJson && res.detailJson[0] && res.detailJson[0].isBuy;
            const previewItem = {
              id: res.recCode || imageID,
              img: res.iconUrl ? res.iconUrl.replace('image.shutterstock.com', 'img.tukuwu.com') : '',
              imgType: this.getImgType(res.searchDTO && res.searchDTO.picType),
              imgSize: res.detailJson && res.detailJson[0] && res.detailJson[0].px || '',
              price: displayPrice,
              orgPrice: res.orgPrice || '',
              type: true, // 可下载
              msg: isFree ? '免费' : '',
              isFree: isFree || false, // 是否免费
              loading: false, // 下载中状态
              complete: false, // 是否已完成下载
              downurl: '', // 主下载链接
              downurl2: '', // 备用下载链接
            };
            this.previewData.push(previewItem);
            // 如果是免费的，自动调用重下接口获取下载链接
            if (isFree) {
              this.downloadFreeItem(this.previewData.length - 1, previewItem);
            }
          } else {
            // 搜索失败
            this.previewData.push({
              id: imageID,
              img: '',
              imgType: '',
              imgSize: '',
              price: 0,
              orgPrice: '',
              type: false, // 获取失败
              msg: res.msg || '素材不存在或已下架',
              isFree: false,
              loading: false,
              complete: false,
            });
          }
        } catch (error) {
          // 搜索出错
          this.previewData.push({
            id: imageID,
            img: '',
            imgType: '',
            imgSize: '',
            price: 0,
            orgPrice: '',
            type: false,
            msg: '搜索失败，请检查ID是否正确',
            isFree: false,
            loading: false,
            complete: false,
          });
        }
      }

      this.isSearching = false;
      this.previewLoading = false;

      // 滚动到预览表格
      setTimeout(() => {
        const previewSection = document.getElementById('position');
        if (previewSection) {
          previewSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 100);
    },
    // 获取图片类型文本
    getImgType(picType) {
      const typeMap = {
        0: 'JPG',
        1: 'ait',
        2: 'indt',
        3: 'psdt',
        4: 'EPS',
        9: '',
        10: 'svg',
        11: 'ai',
        12: 'mdl',
        13: 'wav',
        14: 'PSD',
      };
      return typeMap[picType] || '';
    },
    // 下载免费素材
    async downloadFreeItem(index, item) {
      this.$set(this.previewData, index, { ...item, loading: true });
      try {
        const result = await reDownload({
          imageID: item.id,
          webType: this.list[this.current].webType,
        });
        if (result && result.downloadUrl) {
          this.$set(this.previewData, index, {
            ...this.previewData[index],
            loading: false,
            complete: true,
            downurl: result.downloadUrl.replace('httpss:', 'https:'),
            downurl2: result.downloadUrl2 ? result.downloadUrl2.replace('httpss:', 'https:') : '',
          });
          message.success({
            message: `素材 ${item.id} 下载链接已获取`,
            duration: 3000,
            offset: 100,
          });
        } else {
          this.$set(this.previewData, index, {
            ...this.previewData[index],
            loading: false,
            complete: false,
            msg: '获取下载链接失败',
          });
        }
      } catch (error) {
        this.$set(this.previewData, index, {
          ...this.previewData[index],
          loading: false,
          complete: false,
          msg: '下载失败，请重试',
        });
        message.error({
          message: `素材 ${item.id} 下载失败`,
          duration: 3000,
          offset: 100,
        });
      }
    },
    // 删除预览项
    deletePreviewItem(index) {
      this.previewData.splice(index, 1);
      if (this.previewData.length === 0) {
        this.showPreviewTable = false;
      }
    },
    // 清空预览列表
    clearPreview() {
      this.previewData = [];
      this.showPreviewTable = false;
    },
    // 加载历史工单列表
    async loadWorkOrders() {
      this.tableLoading = true;
      try {
        const res = await queryWorkOrderStatus({});
        console.log("工单列表接口返回:", res);
        // API 封装已处理 code，直接返回 data
        // 可能的结构：{ total: 20, list: [...] } 或直接是数组
        let list = [];
        if (res && res.list && Array.isArray(res.list)) {
          list = res.list;
        } else if (res && Array.isArray(res)) {
          list = res;
        }
        console.log("解析后的列表:", list);
        this.tableDatas = list.map(item => ({
          id: item.workOrderId,
          materialIds: item.materialId ? [item.materialId] : [],
          status: item.status,
          statusText: item.statusText || this.getStatusText(item.status),
          submitTime: item.submitTime,
          completeTime: item.updateTime,
          downloadUrl: item.downloadUrl,
          remark: item.remark || "",
          price: item.price || "",
        }));
        this.showTable = true;
        // 首次加载时已完成的工单不再提示，仅提示后续无感刷新中“新完成”的工单
        this.tableDatas.forEach((o) => {
          if (
            this.isOrderCompleted(o.status) &&
            !this.notifiedOrderIds.includes(o.id)
          ) {
            this.notifiedOrderIds.push(o.id);
          }
        });
        // 如果有待处理的工单，启动轮询
        if (this.tableDatas.length > 0) {
          this.startPolling();
        }
      } catch (error) {
        console.log("加载工单列表失败", error);
        this.showTable = true; // 即使出错也显示表格（空状态）
      } finally {
        this.tableLoading = false;
      }
    },
    // 提交工单
    async submitWorkOrder(params) {
      if (!this.isLoggedIn) {
        message.error({
          message: "您还没登录用户，请登录",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }

      if (params.length === 0) {
        message.error({
          message: "没有可提交的素材",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }

      // 确认弹窗
      const now = new Date();
      const hour = now.getHours();
      const isNightTime = hour >= 0 && hour < 9;

      let confirmMessage = "提交后会立刻扣费，并进入等待模式，等待过程中无法取消订单，如30分钟后下载失败，费用会自动退回";
      if (isNightTime) {
        confirmMessage += "\n\n注意：当前为夜间时段（0点-9点），工单需等待至第二天9点后开始处理";
      }

      this.$confirm(
        confirmMessage,
        "确认提交工单",
        {
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        this.isSubmitting = true;

        try {
          const data = await submitWorkOrder({
            materialIds: params,
            webType: this.list[this.current].webType,
          });

          message.success({
            message: "工单提交成功，请等待处理",
            showClose: true,
            duration: 4000,
            offset: 100,
          });

          // 清空预览数据
          this.previewData = [];
          this.showPreviewTable = false;

          // 重新获取工单列表
          await this.loadWorkOrders();

          // 强制启动轮询（新提交的工单通常是等待处理状态）
          this.startPolling();
        } catch (error) {
          const errorMsg = (error && (error.message || error.msg)) || error;
          if (typeof errorMsg === 'string' && errorMsg.length > 0) {
            message.error({
              message: errorMsg,
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          } else {
            message.error({
              message: "网络异常，请重试",
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
        } finally {
          this.isSubmitting = false;
        }
      }).catch(() => {
        // 用户取消，不做任何操作
      });
    },
    // 刷新工单状态
    async refreshOrderStatus(workOrderId) {
      try {
        const res = await queryWorkOrderStatus({ workOrderId });
        // API 封装已处理 code，res 直接是 data
        // 可能是单个对象或包含 list 的对象
        let updatedItem = null;
        if (res && res.workOrderId) {
          // 直接返回单个对象
          updatedItem = res;
        } else if (res && res.list && res.list.length > 0) {
          // 返回列表，取第一个
          updatedItem = res.list[0];
        }

        if (updatedItem) {
          const index = this.tableDatas.findIndex(item => item.id === workOrderId);
          if (index !== -1) {
            // 处理下载链接 URL 格式（修复 httpss: 问题）
            let downloadUrl = updatedItem.downloadUrl || this.tableDatas[index].downloadUrl;
            let downloadUrl2 = updatedItem.downloadUrl2 || this.tableDatas[index].downloadUrl2;
            if (downloadUrl) {
              downloadUrl = downloadUrl.replace("httpss:", "https:");
            }
            if (downloadUrl2) {
              downloadUrl2 = downloadUrl2.replace("httpss:", "https:");
            }

            this.$set(this.tableDatas, index, {
              ...this.tableDatas[index],
              status: updatedItem.status,
              statusText: updatedItem.statusText || this.getStatusText(updatedItem.status),
              completeTime: updatedItem.completeTime || updatedItem.updateTime,
              downloadUrl: downloadUrl,
              downloadUrl2: downloadUrl2,
              downurl: downloadUrl,        // 兼容 table.vue 中使用的 downurl
              downurl2: downloadUrl2,      // 兼容 table.vue 中使用的 downurl2
              remark: updatedItem.remark || "",
              materialIds: updatedItem.materialId ? [updatedItem.materialId] : this.tableDatas[index].materialIds,
              price: updatedItem.price || this.tableDatas[index].price,
            });

            // 无感刷新中检测到工单变为“已完成”→ 通知消息系统（同一工单只提示一次）
            if (
              this.isOrderCompleted(updatedItem.status) &&
              !this.notifiedOrderIds.includes(workOrderId)
            ) {
              this.notifiedOrderIds.push(workOrderId);
              this.notifyWorkOrderComplete();
            }
          }
        }
      } catch (error) {
        console.log("刷新状态失败", error);
      }
    },
    // 启动轮询
    startPolling() {
      // 先清除旧定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      // 立即执行一次检查
      this.checkAndRefreshPending();
      // 启动定时器，每30秒检查一次
      this.timer = setInterval(() => {
        this.checkAndRefreshPending();
      }, 30000);
    },
    // 检查并刷新待处理工单
    checkAndRefreshPending() {
      // 检查是否有待处理或处理中的工单（支持字符串和数字状态）
      const pendingStatuses = ["pending", "processing", 5, 1, "1", "5"];
      const hasPending = this.tableDatas.some(item => pendingStatuses.includes(item.status));

      if (hasPending) {
        this.tableDatas.forEach(item => {
          if (pendingStatuses.includes(item.status)) {
            this.refreshOrderStatus(item.id);
          }
        });
      }
      // 注意：不再自动停止轮询，让轮询一直运行，避免漏掉状态更新
      // 可以在页面卸载时或长时间无活动后才停止
    },
    // 判断工单是否为“已完成”状态（兼容字符串/数字）
    isOrderCompleted(status) {
      return (
        status === 0 ||
        status === "0" ||
        status === "completed" ||
        status === "已完成"
      );
    },
    // 人工订单下载完成——通知顶部“消息通知”系统新增一条（静态文案）
    notifyWorkOrderComplete() {
      this.$EventBus.$emit("workOrderComplete");
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        pending: "等待处理",
        processing: "处理中",
        completed: "已完成",
        failed: "处理失败",
        0: "已完成",
        1: "处理中",
        2: "处理失败",
        5: "等待处理",
      };
      return statusMap[status] || status;
    },
    // 获取状态样式类型
    getStatusType(status) {
      const typeMap = {
        pending: "warning",
        processing: "",
        completed: "success",
        failed: "danger",
        0: "success",
        1: "",
        2: "danger",
        5: "warning",
      };
      return typeMap[status] || "info";
    },
    // 加载工单历史记录
    async loadWorkOrderHistory() {
      this.historyLoading = true;
      try {
        const res = await queryWorkOrderStatus({
          pageNo: this.historyPageNo,
          pageSize: this.historyPageSize,
        });
        // API 封装已处理 code，直接返回 data
        if (res) {
          // 处理两种可能的返回结构：{ list: [...], total: 20 } 或直接是数组
          let list = [];
          let total = 0;
          if (res.list && Array.isArray(res.list)) {
            list = res.list;
            total = res.total || list.length;
          } else if (Array.isArray(res)) {
            list = res;
            total = list.length;
          }
          this.historyList = list;
          this.historyTotal = total;
        }
      } catch (error) {
        console.log("加载工单历史失败", error);
      } finally {
        this.historyLoading = false;
      }
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.historyPageSize = val;
      this.historyPageNo = 1;
      this.loadWorkOrderHistory();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.historyPageNo = val;
      this.loadWorkOrderHistory();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.body-index1 {
  margin-bottom: 80px;
}
::v-deep li {
  list-style: initial !important;
}
::v-deep ul {
  padding: 0 10px;
}

.page {
  width: 100%;
  height: 100%;

  .main {
    position: absolute;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    p {
      font-size: 14px;
      color: #4a4a4a;
      text-align: center;
      margin-top: 12px;
      margin-bottom: 48px;
    }
    img {
      display: block;
    }
  }
}

.history-section {
  margin-top: 30px;

  .table-container {
    background-color: white;
    padding: 30px;

    .history-table {
      margin-bottom: 20px;

      ::v-deep .el-table__header-wrapper {
        th {
          background-color: #f5f7fa;
          color: #333;
          font-weight: 600;
        }
      }
    }

    .order-id {
      font-family: monospace;
      color: #666;
      font-size: 13px;
    }

    .material-ids {
      .id-tag {
        display: inline-block;
        padding: 2px 8px;
        margin: 2px;
        background: #f0f7ff;
        color: #0773fc;
        border-radius: 4px;
        font-size: 12px;
        font-family: monospace;
      }

      .more-tag {
        display: inline-block;
        padding: 2px 8px;
        margin: 2px;
        background: #e8e8e8;
        color: #666;
        border-radius: 4px;
        font-size: 12px;
      }
    }

    .time {
      font-size: 13px;
      color: #666;

      &.pending {
        color: #999;
      }
    }

    .empty-tips {
      padding: 40px 0;

      .sub-text {
        color: #999;
        font-size: 13px;
        margin-top: 10px;
      }
    }
  }
}
</style>
